<template>
    <div class="p-right-bottom bg-yellow flex w-1/5 p-4 items-center" v-show="show">
        <i class="fas fa-exclamation-circle fa-2x mr-4"></i>
        <div class="flex-shrink text-xs font-thin tracking-wide mr-2">
            {{ message }}
        </div>
        <div class="cursor-pointer" @click="hide">
            &times;
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                message: ''
            }
        },

        created() {
            window.events.$on(
                'flash', message => this.flash(message)
            )
        },

        methods: {
            flash(message) {
                this.message = message;
                this.show = true;
            },

            hide() {
                this.show = false;
            }
        }

    }
</script>